import { useQuery } from '@tanstack/react-query';
import { ctcApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';
import { CtcQueryOverrides } from 'src/api/queries/ctc/ctcSnapshotOptions';

/** @registry CTC cost-to-complete detail for one GP job number. */
export function useCtcJob(
  jobNumber: string | null | undefined,
  overrides?: CtcQueryOverrides,
) {
  return useQuery({
    queryKey: queryKeys.ctc.job(jobNumber ?? ''),
    queryFn: ({ signal }) =>
      ctcApiClient.getCTCJobById(jobNumber!, toCancelToken(signal)),
    staleTime: 0,
    ...overrides,
    enabled: !!jobNumber && (overrides?.enabled ?? true),
    meta: { errorContext: 'CTC job' },
  });
}
